class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]"
    );
    this.overlayEl =
      this.closest(".search-modal")?.querySelector(".modal-overlay");
    this._overlayClickHandler = null;
    this.isOpen = false;
    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector("form.search");
    form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
    this.input.addEventListener("focus", this.onFocus.bind(this));
    // this.addEventListener("focusout", this.onFocusOut.bind(this));
    // this.addEventListener("keyup", this.onKeyup.bind(this));
    // this.addEventListener("keydown", this.onKeydown.bind(this));
    this.predictiveSearchResults.addEventListener(
      "click",
      this.handleBtnsClick.bind(this)
    );
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      // this.close(true);
      this.getSearchResults("");
      return;
    }

    this.getSearchResults(searchTerm);
  }
  handleBtnsClick(event) {
    // event.preventDefault();
    const fullSearchBtn = event.target.closest("button[data-fullsearch]");
    if (fullSearchBtn) {

      const term = fullSearchBtn.dataset.fullsearch;

      // Add market handle to search URL if available
      const cleanHandle = (markethandle || "").replace(/^\/+|\/+$/g, "");
      const prefix = cleanHandle ? `/${cleanHandle}` : "";
      const searchUrl =
        `${prefix}/search?q=${encodeURIComponent(term)}`.replace(
          /\/{2,}/g,
          "/"
        );
      window.location.href = searchUrl;
    }
  }

  onFormSubmit(event, type = "all") {
    event.preventDefault();
    const searchTerm = this.getQuery();
    const redirectUrl = this.findRedirect(searchTerm);


    // Prepare clean market prefix
    const cleanHandle = (markethandle || "").replace(/^\/+|\/+$/g, "");
    const prefix = cleanHandle ? `/${cleanHandle}` : "";


    setTimeout(() => {
      if (redirectUrl && type === "all") {
        // If redirect URL is absolute, insert market handle
        try {
          const url = new URL(redirectUrl);
          if (cleanHandle && !url.pathname.startsWith(`/${cleanHandle}/`)) {
            url.pathname = `/${cleanHandle}${url.pathname}`.replace(
              /\/{2,}/g,
              "/"
            );
          }
          window.location.href = url.toString();
        } catch (err) {
          // fallback if it's relative
          const cleanRedirect = redirectUrl.replace(/^\/+/, "");
          window.location.href = `${prefix}/${cleanRedirect}`.replace(
            /\/{2,}/g,
            "/"
          );
        }
      } else {
        let parameters = "";
        if (type === "male")
          parameters = "&filter.p.m.custom.geschlecht=Herren";
        else if (type === "female")
          parameters = "&filter.p.m.custom.geschlecht=Damen";

        const searchUrl =
          `${prefix}/search?q=${encodeURIComponent(searchTerm)}${parameters}`.replace(
            /\/{2,}/g,
            "/"
          );
        window.location.href = searchUrl;
      }
    }, 10);
  }

  onFocus() {
    // See if the input field is empty.
    if (!this.getQuery().length) {
      this.getSearchResults("");
    }
    return;


    // fill in with default data.

    // this.closeAllOpenFacetsFilters();
    const searchTerm = this.getQuery();
    if (!searchTerm.length) return;

    if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  // onFocusOut() {
  //   setTimeout(() => {
  //     if (!this.contains(document.activeElement)) this.close();
  //   });
  // }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    // if (!this.getAttribute("open")) return;

    // const moveUp = direction === "up";
    // const selectedElement = this.querySelector('[aria-selected="true"]');
    // const allElements = this.querySelectorAll("li");
    // let activeElement = this.querySelector("li");

    // if (moveUp && !selectedElement) return;

    // this.statusElement.textContent = "";

    // if (!moveUp && selectedElement) {
    //   activeElement = selectedElement.nextElementSibling || allElements[0];
    // } else if (moveUp) {
    //   activeElement =
    //     selectedElement.previousElementSibling ||
    //     allElements[allElements.length - 1];
    // }

    // if (activeElement === selectedElement) return;

    // activeElement.setAttribute("aria-selected", true);
    // if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    // this.setLiveRegionText(activeElement.textContent);
    // this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector(
      '[aria-selected="true"] a, [aria-selected="true"] button'
    );
    if (selectedProduct) selectedProduct.click();
  }


  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey], true);
      return;
    }

    if (window.nostoLoadingSearch) {
      this.getNostoSearchResults(searchTerm, queryKey);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&resources[type]=product&resources[limit]=4&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          this.close();
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  getNostoSearchResults(searchTerm, queryKey) {
    nostojs(async (api) => {
      try {
        api.recordSearchSubmit(searchTerm);
        const isSerp = window.location.pathname.includes("/search");

        const response = await api.search(
          {
            query: searchTerm,
            products: {
              facets: ["*"],
              fields: [
                "productId",
                "name",
                "url",
                "imageUrl",
                "price",
                "alternateImageUrls",
              ],
              size: 6,
              from: 0,
              emptyQueryMatchesAll: true,
            },
            popularSearches: {
              fields: ["query"],
              size: 4, // The maximum number of trending searches to fetch
              emptyQueryMatchesAll: true,
            },
            keywords: {
              size: 4, // fetch top keyword suggestions
              emptyQueryMatchesAll: true,
            },
          },
          {
            track: isSerp ? "serp" : "autocomplete",
            redirect: markethandle === "/" && isSerp ? true : false,
            isKeyword: true,
          }
        );

        console.log("NOSTO PREDICTIVE SEARCH RESPONSE", response);

        const products = response.products?.hits || [];
        const keywords = response.keywords?.hits || [];

        if (!products.length && !keywords.length) {
          this.renderSearchResults(
            '<div class="px-4 py-2 text-sm">No results</div>',
            true
          );
          return;
        }

        let productsHtml = "";

        if (products.length && products.length > 0) {
          const firstVariantIds = products
            .map((p) => p.skus?.[0]?.id)
            .filter(Boolean);
          const productHandles = products.map((p) => p.url).filter(Boolean);
          const useHandles = productHandles[0]?.startsWith(
            "https://teveo.com/products"
          );

          const requests = useHandles
            ? productHandles.map((url) => {
              const path = new URL(url).pathname;
              const marketUrl = window.routes.root_url.replace(/\/$/, "");
              return fetchProductCardHTML(
                `${marketUrl}${path}`,
                "recommended-products__item",
                true
              );
            })
            : firstVariantIds.map((id) =>
              fetchProductCardHTMLByFirstVariant(
                id,
                "recommended-products__item"
              )
            );

          const responses = await Promise.all(requests);
          const cardsHtml = responses.join("");

          const tempWrapper = document.createElement("div");
          tempWrapper.innerHTML = cardsHtml;

          tempWrapper
            .querySelectorAll(".product-details__wrapper a")
            .forEach((a) => {
              try {
                const url = new URL(a.href);
                url.searchParams.set("nosto", resultId);
                a.href = url.toString();
              } catch (e) {
                console.warn("Invalid product link", a.href);
              }
            });

          tempWrapper
            .querySelectorAll(".recommended-products__item")
            .forEach((el) => {
              el.classList.remove("recommended-products__item");
              el.classList.add("grid__item");
            });
          productsHtml = tempWrapper.innerHTML;
        }

        // --- KEYWORDS ---
        const keywordHTML = keywords
          .map(
            (kw) => `
          <li class="predictive-search__list-item" role="option" aria-selected="false">
            <button type="button" 
              class="predictive-search__item link link--text" 
              data-fullsearch="${kw.keyword}">
              ${kw._highlight?.keyword ? kw._highlight.keyword : kw.keyword}
            </button>
          </li>`
          )
          .join("");



        const searchForString = this.getAttribute("data-search-search-for") ||
          'Search for "{{ terms }}"';
        const searchBtnHTML =
          searchTerm !== ""
            ? `
        
          <button  class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow"  data-fullsearch="${searchTerm}" >
            ${searchForString.replace("{{ terms }}", searchTerm)}
            <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
            </svg>
          </button>`
            : "";


        const productTitleString = this.getAttribute("data-search-products-title") || 'Products';

        const searchSuggestionsTitleString = this.getAttribute("data-search-suggestions-title") || 'Search suggestions';

        // --- COMBINE ---
        const wrapper = `
        <div>
        <h3 class="predictive-search__column-heading"><strong class="predictive-search__item link link--text">${searchSuggestionsTitleString}</strong></h3>
        <ul id="predictive-search-results-list" role="listbox" class="predictive-search__results-list list-unstyled predictive-search-results__keywords">
          ${keywords.length ? `${keywordHTML}` : ""}
        </ul>
        </div>
        <div>

        <h3 class="predictive-search__column-heading"><strong class="predictive-search__item link link--text">${productTitleString}</strong></h3>
          ${products.length
            ? `<ul id="predictive-search-results-list" role="listbox" class="predictive-search__results-list list-unstyled predictive-search-results__products">
            ${productsHtml}`
            : ""
          }
          </ul>
          ${searchBtnHTML}
        </div>
      `;

        this.cachedResults[queryKey] = wrapper;
        this.renderSearchResults(wrapper, true);

        // --- EVENT TRACKING ---
        setTimeout(() => {
          // Track product clicks
          document.querySelectorAll("[data-nosto-product-id]").forEach((el) => {
            el.addEventListener("click", () => {
              const productId = el.getAttribute("data-nosto-product-id");
              const term = el.getAttribute("data-nosto-search-term");
              api.recordSearchClick(isSerp ? "serp" : "autocomplete", {
                productId: productId,
                url: el.href || "",
              });
            });
          });

          // Track keyword clicks + "See all results"
          document.querySelectorAll("[data-fullsearch]").forEach((btn) => {
            btn.addEventListener("click", () => {
              const term = btn.getAttribute("data-fullsearch");
              api.recordSearchSubmit(term);
            });
          });
        }, 0);
      } catch (err) {
        console.error("Nosto autocomplete error", err);
        this.renderSearchResults(
          '<div class="px-4 py-2 text-sm text-red-600">Error loading results</div>',
          true
        );
      }
    });
  }

  renderSearchResults(resultsMarkup, isRaw = false) {
    this.predictiveSearchResults.innerHTML = isRaw
      ? resultsMarkup
      : resultsMarkup;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    const resultText =
      this.querySelector("[data-predictive-search-live-region-count-value]")
        ?.textContent || "";
    this.setLiveRegionText(resultText);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight -
      document
        .getElementById("shopify-section-new-header")
        .getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.closeAllOpenFacetsFilters();
    // this.predictiveSearchResults.style.maxHeight =
    //   this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute("open", true);
    // Take the rest of the screen height.
    this.input.setAttribute("aria-expanded", true);
    this.showOverlay();
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
    }

    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");

    this.hideOverlay();
    this.isOpen = false;
  }

  closeAllOpenFacetsFilters() {
    const summaryElements = document.querySelectorAll(
      ".facets__wrapper details"
    );
    summaryElements.forEach((summary) => {
      if (summary.hasAttribute("open")) {
        summary.removeAttribute("open");
      }
    });
  }

  showOverlay() {
    if (!this.overlayEl) return;
    // Ensure overlay is visible across contexts (not only when details[open])
    this.overlayEl.style.display = "block";
    document.documentElement.classList.add(`overflow-hidden-all-screens`);
    this.overlayEl.setAttribute("aria-hidden", "false");
    if (!this._overlayClickHandler) {
      this._overlayClickHandler = () => {
        // Allow clicking the overlay to close the predictive search
        this.close(true);
      };
      this.overlayEl.addEventListener("click", this._overlayClickHandler);
    }
  }

  hideOverlay() {
    if (!this.overlayEl) return;
    this.overlayEl.style.display = "";
    this.overlayEl.setAttribute("aria-hidden", "true");
    if (this._overlayClickHandler) {
      this.overlayEl.removeEventListener("click", this._overlayClickHandler);
      this._overlayClickHandler = null;
    }
    document.documentElement.classList.remove(`overflow-hidden-all-screens`);
  }

  findRedirect(searchTerm) {
    for (const category in searchRedirects) {
      const redirects = searchRedirects[category];
      if (redirects) {
        for (const redirectObj of redirects) {
          if (redirectObj && redirectObj.Keyword === searchTerm) {
            return redirectObj.Redirect;
          }
        }
      }
    }
    return null;
  }
}

customElements.define("predictive-search", PredictiveSearch);

// Resize helper (used in Nosto rendering)
const getResizedImageUrlPredictive = (url) => {
  const regex = /(\.[a-zA-Z0-9]+)(\?v=\d+)?$/;
  return url.replace(regex, (match, ext, version) => {
    return `_400x${ext}${version || ""}`;
  });
};
